import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = s((i, e) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: e,
    ...i,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69130)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 4v4a1 1 0 0 0 .293.707l2.5 2.5 1.414-1.414L9 7.586V4z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69130", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
t.displayName = "ClockIcon";
export {
  t as ClockIcon,
  t as default
};
//# sourceMappingURL=index.js.map
